import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateSiteplanLotActiveIndex, updateSiteplanLotOutlines } from '../../redux/actions/siteplanActions';

function PnLSitePlanSVG() {
    var lots = useSelector(state => state.siteplan.lots);

    var dispatch = useDispatch();
    var activeIndex = useSelector(state => state.siteplan.activeIndex);
    var activeLots = useSelector(state => state.siteplan.highlightedLotsIndexes);

    function lotOnClick(index) {
        //make sure this one doesn't have a floorplan
        if (lots[index].floorplan || !lots[index].is_active) {
        }
        else {
            dispatch(updateSiteplanLotActiveIndex(index));
            dispatch(updateSiteplanLotOutlines());
        }
    }

    function fillColourViaType(type, index, active) {
        var fill = "#ABE1FA";

        if (typeof lots[index] != 'undefined') {

        }
        if (lots[index].floorplan) {
            fill = "#5b55a4";
        }
        else {
            if (type == "36'") {
                fill = "#99CA3C";
            }
            if (type == "40'") {
                fill = "#CFBF87";
            }
        }

        if(lots[index].floorplan != "") fill = "#fc7458";
        if(!active) fill = "#A9A9A9";

        return fill;
    }

    function opacityViaActiveState(lotIndex, type, active) {
        var opacity = 0.5;

        if(type == "36'")
        opacity = 0.1;

        if (activeLots.includes(lotIndex))
            opacity = 1.0;

        if (lots[lotIndex].floorplan != "") opacity = 0.85;
        if (!active) opacity = 0.85;

        return opacity;
    }

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1920"
            height="999"
            className='site-plan-svg'
            viewBox="0 0 1920 999"
        >
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g>
                    <path d="M0 0H1920V999H0z"></path>
                    <g fillRule="nonzero" transform="translate(602.129 91.974)">
                        {/** generate our svg here */}
                        {lots && lots.map((lot, iKey) => (
                            <g
                                transform={lot.lot_data.group_transform}
                                onClick={() => lotOnClick(iKey)}
                                style={{
                                    cursor: 'pointer'
                                }}
                            >
                                <path
                                    fill={fillColourViaType(lot.lot_data.path_data.type, iKey, lot.is_active)}
                                    opacity={opacityViaActiveState(iKey, lot.lot_data.path_data.type, lot.is_active)}
                                    stroke={
                                        activeIndex == iKey ?
                                            "#D22B2B" :
                                            lot.lot_data.path_data.stroke
                                    }
                                    strokeWidth={lot.lot_data.path_data.storkewidth}
                                    d={lot.lot_data.path_data.d}
                                    style={{
                                        transitionProperty: 'fill',
                                        transitionDuration: '0.24s',
                                        transitionTimingFunction: 'ease-in'
                                    }}
                                />
                                {lot.lot_data.text_data.texts.length < 2 && lot.lot_data.text_data.texts.length > 0 && (
                                    <text
                                        fill='#000'
                                        fontFamily="AeonikFono-Regular, Aeonik Fono"
                                        fontSize="12"
                                        fontWeight="normal"
                                        transform={lot.lot_data.text_data.transform}
                                    >
                                        <tspan
                                            x={lot.lot_data.text_data.texts[0].position.x}
                                            y={lot.lot_data.text_data.texts[0].position.y}
                                        >
                                            {lot.lot_data.text_data.texts[0].value}
                                        </tspan>
                                    </text>
                                )}
                                {lot.lot_data.text_data.texts.length > 1 && (
                                    <g
                                        fill="#000"
                                        fontFamily="AeonikFono-Regular, Aeonik Fono"
                                        fontSize="12"
                                        transform={lot.lot_data.text_data.transform}
                                    >
                                        {lot.lot_data.text_data.texts.map((txt, key) => (
                                            <text>
                                                <tspan
                                                    x={txt.position.x}
                                                    y={txt.position.y}
                                                >
                                                    {txt.value}
                                                </tspan>
                                            </text>
                                        ))}
                                    </g>
                                )}
                            </g>
                        ))}
                    </g>
                    {/*
                    <g fillRule="nonzero" transform="translate(1189.717 91.139)">
                        <path
                            fill="#778455"
                            stroke="#FFF"
                            strokeWidth="0.5"
                            d="M351.762 91.04c17.285.013 31.784 8.578 43.892 20.911 12.11 12.335 18.503 26.487 18.198 43.769l-3.36 235.173 87.91.76 86.152 1.833L591.886 0 75.59 1.833l-9.165 31.161-15.886 47.047 47.658 7.332 21.996 2.444 21.996.611 209.574.611h0z"
                        ></path>
                        <path
                            fill="#778455"
                            stroke="#FFF"
                            strokeWidth="0.5"
                            d="M351.7622 142.9748L142.188 142.3638 104.3061 140.5309 104.0444 140.5309 97.0571 139.678 90.0698 138.7032 31.414 129.808 23.0171 152.3506 20.259 160.271 17.6848 168.2523 15.3149 176.2336 15.2944 176.2945 13.272 184.0931 11.4331 192.0135 9.8396 199.9339 8.4912 207.9152 7.2654 216.6276 6.2847 225.3401 5.5491 234.1134 5.0588 245.2629 4.5073 265.734 4.5073 265.795 3.5879 300.8884 360.9267 301.2245 363.9824 155.1949z"
                        ></path>
                        <path
                            fill="#778455"
                            stroke="#FFF"
                            strokeWidth="0.5"
                            d="M2.9057 353.4124L1.8765 392.2832 1.0293 423.9648 0.2422 455.6463 0.0605 460.4595 0 467.9534 0 487.267 0 526.1379 346.2627 526.6842 358.4829 514.4644 358.4829 443.5879 359.0937 438.0891 360.3159 353.1595z"
                        ></path>
                        <g
                            fill="#FFF"
                            fontFamily="AeonikFono-Regular, Aeonik Fono"
                            fontSize="12"
                            fontWeight="normal"
                            transform="translate(154.06 202.159)"
                        >
                            <text>
                                <tspan x="12.278" y="11">
                                    F
                                </tspan>
                            </text>
                            <text>
                                <tspan x="17.816" y="11">
                                    U
                                </tspan>
                            </text>
                            <text>
                                <tspan x="25.58" y="11">
                                    T
                                </tspan>
                            </text>
                            <text>
                                <tspan x="31.532" y="11">
                                    U
                                </tspan>
                            </text>
                            <text>
                                <tspan x="39.204" y="11">
                                    R
                                </tspan>
                            </text>
                            <text>
                                <tspan x="45.64" y="11">
                                    E
                                </tspan>
                            </text>
                            <text>
                                <tspan x="0" y="25.4">
                                    R
                                </tspan>
                            </text>
                            <text>
                                <tspan x="6.436" y="25.4">
                                    E
                                </tspan>
                            </text>
                            <text>
                                <tspan x="12.297" y="25.4">
                                    S
                                </tspan>
                            </text>
                            <text>
                                <tspan x="18.014" y="25.4">
                                    I
                                </tspan>
                            </text>
                            <text>
                                <tspan x="20.792" y="25.4">
                                    D
                                </tspan>
                            </text>
                            <text>
                                <tspan x="28.733" y="25.4">
                                    E
                                </tspan>
                            </text>
                            <text>
                                <tspan x="34.452" y="25.4">
                                    N
                                </tspan>
                            </text>
                            <text>
                                <tspan x="42.341" y="25.4">
                                    T
                                </tspan>
                            </text>
                            <text>
                                <tspan x="48.287" y="25.4">
                                    I
                                </tspan>
                            </text>
                            <text>
                                <tspan x="50.969" y="25.4">
                                    A
                                </tspan>
                            </text>
                            <text>
                                <tspan x="58.157" y="25.4">
                                    L
                                </tspan>
                            </text>
                        </g>
                        <g
                            fill="#FFF"
                            fontFamily="AeonikFono-Regular, Aeonik Fono"
                            fontSize="12"
                            fontWeight="normal"
                            transform="translate(463.93 59.538)"
                        >
                            <text>
                                <tspan x="12.278" y="11">
                                    F
                                </tspan>
                            </text>
                            <text>
                                <tspan x="17.816" y="11">
                                    U
                                </tspan>
                            </text>
                            <text>
                                <tspan x="25.58" y="11">
                                    T
                                </tspan>
                            </text>
                            <text>
                                <tspan x="31.532" y="11">
                                    U
                                </tspan>
                            </text>
                            <text>
                                <tspan x="39.204" y="11">
                                    R
                                </tspan>
                            </text>
                            <text>
                                <tspan x="45.64" y="11">
                                    E
                                </tspan>
                            </text>
                            <text>
                                <tspan x="0" y="25.4">
                                    R
                                </tspan>
                            </text>
                            <text>
                                <tspan x="6.436" y="25.4">
                                    E
                                </tspan>
                            </text>
                            <text>
                                <tspan x="12.297" y="25.4">
                                    S
                                </tspan>
                            </text>
                            <text>
                                <tspan x="18.014" y="25.4">
                                    I
                                </tspan>
                            </text>
                            <text>
                                <tspan x="20.792" y="25.4">
                                    D
                                </tspan>
                            </text>
                            <text>
                                <tspan x="28.733" y="25.4">
                                    E
                                </tspan>
                            </text>
                            <text>
                                <tspan x="34.452" y="25.4">
                                    N
                                </tspan>
                            </text>
                            <text>
                                <tspan x="42.341" y="25.4">
                                    T
                                </tspan>
                            </text>
                            <text>
                                <tspan x="48.287" y="25.4">
                                    I
                                </tspan>
                            </text>
                            <text>
                                <tspan x="50.969" y="25.4">
                                    A
                                </tspan>
                            </text>
                            <text>
                                <tspan x="58.157" y="25.4">
                                    L
                                </tspan>
                            </text>
                        </g>
                        <g
                            fill="#FFF"
                            fontFamily="AeonikFono-Regular, Aeonik Fono"
                            fontSize="12"
                            fontWeight="normal"
                            transform="translate(143 426.453)"
                        >
                            <text>
                                <tspan x="12.278" y="11">
                                    F
                                </tspan>
                            </text>
                            <text>
                                <tspan x="17.816" y="11">
                                    U
                                </tspan>
                            </text>
                            <text>
                                <tspan x="25.58" y="11">
                                    T
                                </tspan>
                            </text>
                            <text>
                                <tspan x="31.532" y="11">
                                    U
                                </tspan>
                            </text>
                            <text>
                                <tspan x="39.204" y="11">
                                    R
                                </tspan>
                            </text>
                            <text>
                                <tspan x="45.64" y="11">
                                    E
                                </tspan>
                            </text>
                            <text>
                                <tspan x="0" y="25.4">
                                    R
                                </tspan>
                            </text>
                            <text>
                                <tspan x="6.436" y="25.4">
                                    E
                                </tspan>
                            </text>
                            <text>
                                <tspan x="12.297" y="25.4">
                                    S
                                </tspan>
                            </text>
                            <text>
                                <tspan x="18.014" y="25.4">
                                    I
                                </tspan>
                            </text>
                            <text>
                                <tspan x="20.792" y="25.4">
                                    D
                                </tspan>
                            </text>
                            <text>
                                <tspan x="28.733" y="25.4">
                                    E
                                </tspan>
                            </text>
                            <text>
                                <tspan x="34.452" y="25.4">
                                    N
                                </tspan>
                            </text>
                            <text>
                                <tspan x="42.341" y="25.4">
                                    T
                                </tspan>
                            </text>
                            <text>
                                <tspan x="48.287" y="25.4">
                                    I
                                </tspan>
                            </text>
                            <text>
                                <tspan x="50.969" y="25.4">
                                    A
                                </tspan>
                            </text>
                            <text>
                                <tspan x="58.157" y="25.4">
                                    L
                                </tspan>
                            </text>
                        </g>
                    </g>
                    */}
                    <g id="Future" transform="translate(1240.255, 91.1388)" fill-rule="nonzero">
                        <g id="Group" transform="translate(36.9325, 140.1043)" fill="#778455" stroke="#FFFFFF" strokeWidth="0.5">
                            <polygon id="Path" points="264.291992 2.8703614 54.7177734 2.2593994 16.8359375 0.4264527 16.5742188 0.4265137 13.0805664 0 16.5742188 0.4265137 15.9614258 36.1901245 15.4145508 67.810791 14.965332 94.0090332 14.4189453 125.690552 13.815918 160.783997 273.456543 161.120056 276.512207 15.0905152"></polygon>
                            <polygon id="Path" points="0 213.307983 0 252.178833 0 283.860352 0 315.541931 0 347.162598 0 386.033447 258.792481 386.579834 271.012695 374.359985 271.012695 303.483459 271.623535 297.98468 272.845703 213.055054"></polygon>
                        </g>
                    </g>
                    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                        
                        <g fillRule="nonzero" transform="translate(1189.717 91.139)">
                            <path
                                fill="#778455"
                                stroke="#FFF"
                                strokeWidth="0.5"
                                d="M351.762 91.04c17.285.013 31.784 8.578 43.892 20.911 12.11 12.335 18.503 26.487 18.198 43.769l-3.36 235.173 87.91.76 86.152 1.833L591.886 0 75.59 1.833l-9.165 31.161-15.886 47.047 47.658 7.332 21.996 2.444 21.996.611 209.574.611h0z"
                            ></path>
                            {/*
                            <path
                                fill="#778455"
                                stroke="#FFF"
                                strokeWidth="0.5"
                                d="M351.7622 142.9748L142.188 142.3638 104.3061 140.5309 104.0444 140.5309 97.0571 139.678 90.0698 138.7032 31.414 129.808 23.0171 152.3506 20.259 160.271 17.6848 168.2523 15.3149 176.2336 15.2944 176.2945 13.272 184.0931 11.4331 192.0135 9.8396 199.9339 8.4912 207.9152 7.2654 216.6276 6.2847 225.3401 5.5491 234.1134 5.0588 245.2629 4.5073 265.734 4.5073 265.795 3.5879 300.8884 360.9267 301.2245 363.9824 155.1949z"
                            ></path>
                            <path
                                fill="#778455"
                                stroke="#FFF"
                                strokeWidth="0.5"
                                d="M2.9057 353.4124L1.8765 392.2832 1.0293 423.9648 0.2422 455.6463 0.0605 460.4595 0 467.9534 0 487.267 0 526.1379 346.2627 526.6842 358.4829 514.4644 358.4829 443.5879 359.0937 438.0891 360.3159 353.1595z"
                            ></path>
                        */ }
                            <g
                                fill="#FFF"
                                fontFamily="AeonikFono-Regular, Aeonik Fono"
                                fontSize="12"
                                fontWeight="normal"
                                transform="translate(154.06 202.159)"
                            >
                                <text>
                                    <tspan x="12.278" y="11">
                                        F
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="18.816" y="11">
                                        U
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="26.58" y="11">
                                        T
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="33.532" y="11">
                                        U
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="41.204" y="11">
                                        R
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="48.64" y="11">
                                        E
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="0" y="25.4">
                                        R
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="6.436" y="25.4">
                                        E
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="12.297" y="25.4">
                                        S
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="19.014" y="25.4">
                                        I
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="24.792" y="25.4">
                                        D
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="32.733" y="25.4">
                                        E
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="39.452" y="25.4">
                                        N
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="47.341" y="25.4">
                                        T
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="54.287" y="25.4">
                                        I
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="60.969" y="25.4">
                                        A
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="69.157" y="25.4">
                                        L
                                    </tspan>
                                </text>
                            </g>
                            <g
                                fill="#FFF"
                                fontFamily="AeonikFono-Regular, Aeonik Fono"
                                fontSize="12"
                                fontWeight="normal"
                                transform="translate(463.93 59.538)"
                            >
                                <text>
                                    <tspan x="12.278" y="11">
                                        F
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="18.816" y="11">
                                        U
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="26.58" y="11">
                                        T
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="33.532" y="11">
                                        U
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="41.204" y="11">
                                        R
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="48.64" y="11">
                                        E
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="0" y="25.4">
                                        R
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="6.436" y="25.4">
                                        E
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="12.297" y="25.4">
                                        S
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="19.014" y="25.4">
                                        I
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="24.792" y="25.4">
                                        D
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="32.733" y="25.4">
                                        E
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="39.452" y="25.4">
                                        N
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="47.341" y="25.4">
                                        T
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="54.287" y="25.4">
                                        I
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="60.969" y="25.4">
                                        A
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="69.157" y="25.4">
                                        L
                                    </tspan>
                                </text>
                            </g>
                            <g
                                fill="#FFF"
                                fontFamily="AeonikFono-Regular, Aeonik Fono"
                                fontSize="12"
                                fontWeight="normal"
                                transform="translate(143 426.453)"
                            >
                                <text>
                                    <tspan x="12.278" y="11">
                                        F
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="19.816" y="11">
                                        U
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="28.58" y="11">
                                        T
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="35.532" y="11">
                                        U
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="43.204" y="11">
                                        R
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="51.64" y="11">
                                        E
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="0" y="25.4">
                                        R
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="7.436" y="25.4">
                                        E
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="14.297" y="25.4">
                                        S
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="21.014" y="25.4">
                                        I
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="26.792" y="25.4">
                                        D
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="34.733" y="25.4">
                                        E
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="41.452" y="25.4">
                                        N
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="49.341" y="25.4">
                                        T
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="56.287" y="25.4">
                                        I
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="61.969" y="25.4">
                                        A
                                    </tspan>
                                </text>
                                <text>
                                    <tspan x="70.157" y="25.4">
                                        L
                                    </tspan>
                                </text>
                            </g>
                        </g>
                    </g>

                    <g id="labels" transform="translate(706.9027, 195.8095)" fill="#FFFFFF" fillRule="nonzero" fontFamily="AeonikFono-Regular, Aeonik Fono" fontSize="12" fontWeight="normal">
                            <g id="Group" transform="translate(293.7056, 440.309)">
                                <text id="M">
                                    <tspan x="0" y="11">M</tspan>
                                </text>
                                <text id="A">
                                    <tspan x="9.59375" y="11">A</tspan>
                                </text>
                                <text id="Y">
                                    <tspan x="16.0043945" y="11">Y</tspan>
                                </text>
                                <text id="P">
                                    <tspan x="23.4658203" y="11">P</tspan>
                                </text>
                                <text id="O">
                                    <tspan x="30.7539062" y="11">O</tspan>
                                </text>
                                <text id="R">
                                    <tspan x="39.9931641" y="11">R</tspan>
                                </text>
                                <text id="T">
                                    <tspan x="48.4790039" y="11">T</tspan>
                                </text>
                                <text id="D">
                                    <tspan x="57.9868164" y="11">D</tspan>
                                </text>
                                <text id="R">
                                    <tspan x="66.9282227" y="11">R</tspan>
                                </text>
                                <text id="I">
                                    <tspan x="75.3842773" y="11">I</tspan>
                                </text>
                                <text id="V">
                                    <tspan x="79.1923828" y="11">V</tspan>
                                </text>
                                <text id="E">
                                    <tspan x="86.8823242" y="11">E</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(524.4876, 215.9835)">
                                <text id="E">
                                    <tspan x="0" y="11">E</tspan>
                                </text>
                                <text id="V">
                                    <tspan x="8" y="11">V</tspan>
                                </text>
                                <text id="E">
                                    <tspan x="15.6899414" y="11">E</tspan>
                                </text>
                                <text id="R">
                                    <tspan x="23.4077148" y="11">R</tspan>
                                </text>
                                <text id="E">
                                    <tspan x="31.8432617" y="11">E</tspan>
                                </text>
                                <text id="T">
                                    <tspan x="40.8789062" y="11">T</tspan>
                                </text>
                                <text id="T">
                                    <tspan x="49.2919922" y="11">T</tspan>
                                </text>
                                <text id="W">
                                    <tspan x="58.7998047" y="11">W</tspan>
                                </text>
                                <text id="A">
                                    <tspan x="68.3876953" y="11">A</tspan>
                                </text>
                                <text id="R">
                                    <tspan x="76.5756836" y="11">R</tspan>
                                </text>
                                <text id="N">
                                    <tspan x="84.0112305" y="11">N</tspan>
                                </text>
                                <text id="E">
                                    <tspan x="91.8383789" y="11">E</tspan>
                                </text>
                                <text id="A">
                                    <tspan x="100.286133" y="11">A</tspan>
                                </text>
                                <text id="V">
                                    <tspan x="106.98584" y="11">V</tspan>
                                </text>
                                <text id="E">
                                    <tspan x="114.675781" y="11">E</tspan>
                                </text>
                                <text id="N">
                                    <tspan x="122.393555" y="11">N</tspan>
                                </text>
                                <text id="U">
                                    <tspan x="130.205566" y="11">U</tspan>
                                </text>
                                <text id="E">
                                    <tspan x="137.878418" y="11">E</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(8.2963, 184.8764) rotate(-88.4947) translate(-8.2963, -184.8764)translate(-37.6436, 177.7844)">
                                <text id="M">
                                    <tspan x="-2.45376685e-13" y="11.1838909">M</tspan>
                                </text>
                                <text id="A">
                                    <tspan x="9.59375" y="11.1838909">A</tspan>
                                </text>
                                <text id="Y">
                                    <tspan x="16.0043945" y="11.1838909">Y</tspan>
                                </text>
                                <text id="P">
                                    <tspan x="23.4654752" y="11.1576208">P</tspan>
                                </text>
                                <text id="O">
                                    <tspan x="30.753216" y="11.1313506">O</tspan>
                                </text>
                                <text id="R">
                                    <tspan x="38.9924739" y="11.1313506">R</tspan>
                                </text>
                                <text id="T">
                                    <tspan x="47.4776234" y="11.0788104">T</tspan>
                                </text>
                                <text id="D">
                                    <tspan x="54.985781" y="11.1050805">D</tspan>
                                </text>
                                <text id="R">
                                    <tspan x="63.9268422" y="11.0788104">R</tspan>
                                </text>
                                <text id="I">
                                    <tspan x="72.3822066" y="11.0262701">I</tspan>
                                </text>
                                <text id="V">
                                    <tspan x="75.1903121" y="11.0262701">V</tspan>
                                </text>
                                <text id="E">
                                    <tspan x="82.8799084" y="11">E</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(233.8997, 185.0746) rotate(-89.2185) translate(-233.8997, -185.0746)translate(181.0142, 177.9723)">
                                <text id="S">
                                    <tspan x="4.42650778e-14" y="11.2045994">S</tspan>
                                </text>
                                <text id="E">
                                    <tspan x="7.72247014" y="11.1773195">E</tspan>
                                </text>
                                <text id="A">
                                    <tspan x="15.6861513" y="11.1500395">A</tspan>
                                </text>
                                <text id="B">
                                    <tspan x="23.8740466" y="11.1363996">B</tspan>
                                </text>
                                <text id="R">
                                    <tspan x="31.319266" y="11.1227596">R</tspan>
                                </text>
                                <text id="I">
                                    <tspan x="38.7752277" y="11.1091197">I</tspan>
                                </text>
                                <text id="N">
                                    <tspan x="41.5530597" y="11.1091197">N</tspan>
                                </text>
                                <text id="G">
                                    <tspan x="50.4045292" y="11.0954797">G</tspan>
                                </text>
                                <text id="S">
                                    <tspan x="59.7005207" y="11.1091197">S</tspan>
                                </text>
                                <text id="TR">
                                    <tspan x="67.6339283" y="11.0818398">TR</tspan>
                                </text>
                                <text id="E">
                                    <tspan x="83.0174384" y="11.0409199">E</tspan>
                                </text>
                                <text id="E">
                                    <tspan x="89.735607" y="11.0272799">E</tspan>
                                </text>
                                <text id="T">
                                    <tspan x="97.7710655" y="11">T</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(457.6287, 247.3571) rotate(-88.9714) translate(-457.6287, -247.3571)translate(453.6287, 240.3571)">
                                <text id="T">
                                    <tspan x="0" y="11">T</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(457.7461, 239.9002) rotate(-88.9714) translate(-457.7461, -239.9002)translate(453.2461, 232.9002)">
                                <text id="R">
                                    <tspan x="0" y="11">R</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(457.8643, 232.2966) rotate(-88.9709) translate(-457.8643, -232.2966)translate(453.3643, 225.2966)">
                                <text id="A">
                                    <tspan x="0" y="11">A</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(457.9932, 225.114) rotate(-88.9709) translate(-457.9932, -225.114)translate(453.4932, 218.114)">
                                <text id="D">
                                    <tspan x="0" y="11">D</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(458.1358, 217.1599) rotate(-88.9712) translate(-458.1358, -217.1599)translate(453.6358, 210.1599)">
                                <text id="E">
                                    <tspan x="0" y="11">E</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(458.2692, 208.7237) rotate(-88.9712) translate(-458.2692, -208.7237)translate(452.2692, 201.7237)">
                                <text id="W">
                                    <tspan x="0" y="11">W</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(458.3789, 201.6235) rotate(-88.9724) translate(-458.3789, -201.6235)translate(456.3789, 194.6235)">
                                <text id="I">
                                    <tspan x="0" y="11">I</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(458.4727, 196.3518) rotate(-88.9713) translate(-458.4727, -196.3518)translate(453.9727, 189.3518)">
                                <text id="N">
                                    <tspan x="0" y="11">N</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(458.6132, 188.5326) rotate(-88.9729) translate(-458.6132, -188.5326)translate(454.1132, 181.5326)">
                                <text id="D">
                                    <tspan x="0" y="11">D</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(458.9208, 180.4894) rotate(-87.6152) translate(-458.9208, -180.4894)translate(454.4208, 173.4894)">
                                <text id="S">
                                    <tspan x="0" y="11">S</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(459.2664, 173.0513) rotate(-87.6647) translate(-459.2664, -173.0513)translate(454.7664, 166.0513)">
                                <text id="S">
                                    <tspan x="0" y="11">S</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(459.485, 165.6364) rotate(-87.7092) translate(-459.485, -165.6364)translate(455.485, 158.6364)">
                                <text id="T">
                                    <tspan x="0" y="11">T</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(459.7392, 158.1991) rotate(-87.7588) translate(-459.7392, -158.1991)translate(455.2392, 151.1991)">
                                <text id="R">
                                    <tspan x="0" y="11">R</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(459.9853, 150.7808) rotate(-87.8197) translate(-459.9853, -150.7808)translate(455.4853, 143.7808)">
                                <text id="E">
                                    <tspan x="0" y="11">E</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(460.1951, 143.0915) rotate(-87.8941) translate(-460.1951, -143.0915)translate(455.6951, 136.0915)">
                                <text id="E">
                                    <tspan x="0" y="11">E</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(460.3921, 135.5671) rotate(-88.0078) translate(-460.3921, -135.5671)translate(456.3921, 128.5671)">
                                <text id="T">
                                    <tspan x="0" y="11">T</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(564.946, 7.6335) rotate(8.0836) translate(-564.946, -7.6335)translate(559.946, 0.6335)">
                                <text id="M">
                                    <tspan x="0" y="11">M</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(573.9125, 8.8912) rotate(7.8917) translate(-573.9125, -8.8912)translate(569.4125, 1.8912)">
                                <text id="A">
                                    <tspan x="0" y="11">A</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(580.2043, 9.7484) rotate(7.6882) translate(-580.2043, -9.7484)translate(575.7043, 2.7484)">
                                <text id="Y">
                                    <tspan x="0" y="11">Y</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(587.5334, 10.578) rotate(7.3403) translate(-587.5334, -10.578)translate(583.0334, 3.578)">
                                <text id="P">
                                    <tspan x="0" y="11">P</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(596.0589, 11.3243) rotate(5.6864) translate(-596.0589, -11.3243)translate(591.0589, 4.3243)">
                                <text id="O">
                                    <tspan x="0" y="11">O</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(604.3901, 11.8865) rotate(3.7918) translate(-604.3901, -11.8865)translate(599.8901, 4.8865)">
                                <text id="R">
                                    <tspan x="0" y="11">R</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(612.1044, 12.1866) rotate(2.7135) translate(-612.1044, -12.1866)translate(608.1044, 5.1866)">
                                <text id="T">
                                    <tspan x="0" y="11">T</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(620.8317, 12.4887) rotate(1.5345) translate(-620.8317, -12.4887)translate(616.3317, 5.4887)">
                                <text id="D">
                                    <tspan x="0" y="11">D</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(628.625, 12.6403) rotate(0.8659) translate(-628.625, -12.6403)translate(624.125, 5.6403)">
                                <text id="R">
                                    <tspan x="0" y="11">R</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(633.4758, 12.6797) rotate(0.4981) translate(-633.4758, -12.6797)translate(631.4758, 5.6797)">
                                <text id="I">
                                    <tspan x="0" y="11">I</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(638.7044, 12.7043) rotate(0.1631) translate(-638.7044, -12.7043)translate(634.2044, 5.7043)">
                                <text id="V">
                                    <tspan x="0" y="11">V</tspan>
                                </text>
                            </g>
                            <g id="Group" transform="translate(646.3119, 12.6902) rotate(-0.2404) translate(-646.3119, -12.6902)translate(641.8119, 5.6902)">
                                <text id="E">
                                    <tspan x="-1.60205553e-13" y="11">E</tspan>
                                </text>
                            </g>
                        </g>
                </g>
            </g>
        </svg>
    )
}

export default PnLSitePlanSVG;